class APIConstant {
  public readonly CMS_QUESTION_ALL = "cms/question";
  public readonly CMS_QUESTION_EXPORT = "cms/Question/Export";
  public readonly CMS_QUESTION_TYPE = "cms/QuestionTypes";
  public readonly CMS_QUESTION_DELETE = "cms/question";
  public readonly CMS_QUESTIONTAG = "/cms/question/tag";
  public readonly CMS_PAYLOAD_SCHEMA = "cms/QuestionType/PayloadSchema";
  public readonly CMS_QUESTION_VALIDATE_EXTERNALSOURCEID =
    "cms/question/validateExternalSourceId";

  public readonly CMS_QUESTION = "cms/question";
  public readonly CMS_QUESTION_BY_QUESTION_GUID = "cms/question";
  public readonly CMS_QUESTIONIMAGE = "cms/QuestionImage";
  public readonly CMS_QUESTION_SAVE = "cms/Question/Save";
  public readonly CMS_QUESTIONSETTINGS = "cms/Question/Settings";
  public readonly CMS_QUESTION_QUESTION_GUID = "cms/Question/:id/question-guid";
  public readonly CMS_QUESTION_ASSET_UPLOAD =
    "cms/Question/upload-learnosity-asset";
  public readonly CMS_VIDEO_THUMBNAIL_UPLOAD = "cms/video/upload-thumbnail";
  public readonly CMS_CATEGORY = "cms/category";
  public readonly CMS_CONTENT_AREA_ALL = "cms/ContentArea";
  public readonly CMS_CONTENT_AREA = "cms/ContentArea";
  public readonly CMS_DOMAIN_ALL = "cms/Domain";
  public readonly CMS_DOMAIN_EXPORT = "cms/domainExport";
  public readonly CMS_GRADE = "cms/Grade";
  public readonly CMS_STATE = "cms/State";
  public readonly CMS_STATE_ALL = "cms/StateAll";
  public readonly CMS_DOMAIN = "cms/domain";
  public readonly CMS_DOMAIN_DETAILS = "cms/domain/Detail";
  public readonly CMS_PASSAGE_ALL = "cms/Passage";
  public readonly CMS_PASSAGE_CAT_OLD_TYPE = "cms/passage/categoryOldType";
  public readonly CMS_PASSAGE_CATEGORIES = "cms/passage/categories";
  public readonly CMS_PASSAGE = "cms/passage";
  public readonly CMS_PASSAGEBYID = "cms/passage/details";
  public readonly CMS_PASSAGESOURCETYPE = "/cms/passage/sourceType";
  public readonly CMS_PASSAGEdIFFICULTYTYPE = "/cms/passage/difficultyType";
  public readonly CMS_PASSAGELITERATURETYPE = "/cms/passage/literatureType";
  public readonly CMS_PASSAGEDATATYPE = "/cms/passage/dateType";
  public readonly CMS_PASSAGEGRAMMARTYPE = "cms/passage/grammarType";
  public readonly CMS_PASSAGEPOSTQUESTION = "cms/passagequestion";
  public readonly CMS_PASSAGEDELETEQUESTION = "/cms/passagequestion";
  public readonly CMS_PASSAGETAG = "/cms/passage/tag";
  public readonly CMS_PASSAGE_BY_QUESTION_ID =
    "/cms/PassageQuestion/GetByQuestionId";
  public readonly CMS_PASSAGE_CLASSIFICATION = "/cms/passage/Classifications";
  public readonly CMS_AUTHOUR = "/cms/question/Authors";
  public readonly CMS_QUESTION_CLASSIFICATION = "/cms/question/Classifications";
  public readonly CMS_SKILL_SUBJECT_ALL = "cms/SkillSubject";
  public readonly CMS_SKILL_SUBJECT_EXPORT = "cms/SkillSubjectExport";
  public readonly CMS_SKILL_SUBJECT = "cms/SkillSubject";
  public readonly CMS_SKILL_SUBJECT_ONE = "cms/SkillSubject/";
  public readonly CMS_SKILL_STANDARD_ALL = "cms/SkillStandard";
  public readonly CMS_SKILL_STANDARD = "cms/SkillStandard";
  public readonly CMS_SKILL_STANDARD_ONE = "cms/SkillStandard/";
  public readonly CMS_SKILL_QUESTION_ALL = "cms/SkillQuestion";
  public readonly CMS_SKILL_QUESTION = "cms/SkillQuestion";
  public readonly CMS_SKILL_QUESTION_ONE = "cms/SkillQuestion/";
  public readonly CMS_STANDARD = "cms/standard";
  public readonly CMS_STANDARD_BY_WORKSHEETID =
    "cms/standard/standardsByWorksheetId";
  public readonly CMS_STANDARD_BY_SLIDEID = "cms/standard/standards-by-slideid";
  public readonly CMS_STANDARD_DETAIL = "cms/standard/detail";
  public readonly CMS_STANDARD_BY_QUESTIONID =
    "cms/standard/standardsByQuestionId";
  public readonly CMS_UNASSOCIATED_STANDARD = "cms/standard/unassociated";
  public readonly CMS_STANDARD_MAGIC_MATCH = "cms/standard/magic-match";

  public readonly CMS_SUBJECT_ALL = "cms/subject";
  public readonly CMS_SUBJECT_ALL_BY_CONTENTID =
    "cms/subject/ContentAreaSubjects";
  public readonly CMS_GRADE_ALL = "cms/Grade";
  public readonly CMS_GRADESTANDARD = "cms/Grade/gradestandard";
  public readonly CMS_SUBJECTC_DETAIL = "cms/subject/detail";
  public readonly CMS_SUBJECTC_MULTIPLE_STANDARDS =
    "cms/subject/Classifycleanup";
  public readonly CMS_SUBJECT = "cms/subject";
  public readonly CMS_SUBJECT_CLONE = "cms/subject/Clone";
  public readonly CMS_SUBJECT_ICON = "cms/subject/uploadIcon";
  public readonly CMS_TAG_ALL = "cms/tag";
  public readonly CMS_TAG = "cms/tag";
  public readonly CMS_SUBJECT_SCORINGALGORITHM =
    "cms/subject/scoringalgorithms";
  public readonly CMS_CANNED_TEST_TYPE_ALL = "cms/cannedtest/types";
  public readonly CMS_CANNED_RECOMMENDED_STANDARDS =
    "cms/cannedtest/recommendedstandards";
  public readonly CMS_CANNED_TESTS = "cms/cannedtests";
  public readonly CMS_CANNED_TEST = "cms/cannedtest";
  public readonly CMS_COPYQUESTIONS_TEST = "cms/cannedtest/questions-copy";
  public readonly CMS_CANNED_TEST_SECTION = "cms/cannedtestsection";
  public readonly CMS_CANNED_TEST_SECTION_GROUP = "cms/cannedtestsectiongroup";
  public readonly CMS_CANNED_TEST_IS_QUESTION_VALID =
    "cms/cannedtest/isQuestionValid";
  public readonly CMS_CANNED_SEARCH_QUESTIONS =
    "cms/cannedtest/searchquestions";
  public readonly CMS_CANNED_TESTS_GET_SUBJECTS = "cms/cannedtests/subjects";

  public readonly CMS_LINKEDSTANDARD = "cms/standardLinking";
  public readonly CMS_LINKEDSTANDARDS = "cms/standardLinking/LinkedStandards";
  public readonly CMS_CANNED_TEST_Import_File = "cms/cannedtest/importFile";
  public readonly CMS_LINKEDSTANDARD_ALL = "cms/standardLinking";
  public readonly CMS_LIFTOFFSUBJECT = "cms/liftoffsubject";
  public readonly CMS_LIFTOFFGALAXYSTANDARD = "cms/liftoffgalaxystandard";

  public readonly CMS_CANNED_TEST_COPY = "cms/cannedtest/copy";
  public readonly CMS_SELLABLE_PRODUCT = "cms/SellableProduct";
  public readonly CMS_ADD_PRODUCT_EXISTING = "cms/SellableProductSubject";
  public readonly CMS_SELLABLE_PRODUCT_SUBJECTS = "cms/SellableProductSubject";
  public readonly CMS_SELLABLE_PRODUCT_CANNED_TESTS =
    "cms/SellableProductCannedTest";
  public readonly CMS_SELLABLE_PRODUCT_ITEM_BANKS =
    "cms/SellableProductItemBank";
  public readonly CMS_SELLABLE_PRODUCT_TYPE = "cms/SellableProductType";
  public readonly CMS_ITEM_BANK = "cms/ItemBank";

  public readonly CMS_LIFTOFFDIAGNOSTICTEST = "cms/liftoffdiagnostictest";
  public readonly CMS_LIFTOFFDIAGNOSTICTESTQUESTION =
    "cms/liftoffdiagnostictestquestion";
  public readonly CMS_SUBJECT_TYPES = "cms/subject/SubjectTypes";

  public readonly CMS_WORKSHEET_SAVE = "cms/worksheet/save";
  public readonly CMS_WORKSHEETS = "cms/worksheets";
  public readonly CMS_WORKSHEET = "cms/worksheet";

  public readonly CMS_WORKSHEETTAG = "/cms/worksheet/tag";
  public readonly CMS_WORKSHEET_PREVIEW = "cms/worksheet/preview";
  public readonly CMS_WORKSHEET_UNASSOCIATE_STANDARDS =
    "cms/worksheet/unassociate-standards";

  public readonly CMS_STANDARD_WORKSHEETS = "cms/standardworksheets";
  public readonly CMS_STANDARD_SLIDES = "cms/standard-slides";

  public readonly CMS_BUNDLE = "/cms/Bundle";
  public readonly CMS_BUNDLE_EXTENDED_DATE = "/cms/Bundle/ExtendedEndDate";
  public readonly CMS_BUNDLE_SCHOOL = "/cms/Bundle/School";
  public readonly CMS_COPY_BUNDLE = "cms/Bundle/copy";
  public readonly CMS_BUNDLE_EXTENDED_DATE_ALL =
    "/cms/Bundle/update-extended-end-date-all";
  //public readonly CMS_BUNDLE_GET_ALL_BUNDLES_BY_ACCOUNT_ID = "cms/Bundle/account";

  public readonly CMS_BUNDLE_SELLABLE_PRODUCT = "/cms/BundleSellableProduct";
  public readonly CMS_BUNDLESELLEABLESUBJECT = "/cms/SellableProductSubject";

  public readonly CMS_PERMISSION_GROUP = "/cms/PermissionGroup";
  public readonly CMS_PERMISSION_GROUP_ACCESS = "/cms/PermissionGroupAccess";
  public readonly CMS_PERMISSION_GROUP_BY_ID =
    "/cms/PermissionGroup/GetByPermissionGroupId";

  public readonly CMS_PERMISSION_GROUP_ACCESS_BY_ID =
    "/cms/PermissionGroupAccess/{permissionGroupId}/permissions";

  public readonly CMS_PERMISSION_GROUP_ACCESS_BY_ID_AllPERMISSIONS =
    "/cms/PermissionGroupAccess/{permissionGroupId}/all-permissions";

  public readonly CMS_STANDARDVIDEO = "/cms/standardvideo";
  public readonly CMS_STANDARWORKSHEET = "/cms/standardworksheet";
  public readonly CMS_STANDARDSLIDE = "/cms/standardslide";
  public readonly CMS_VIDEOALL = "/cms/video";
  public readonly CMS_VIDEO = "/cms/video";
  public readonly CMS_VIDEOTAG = "/cms/videotag";
  public readonly CMS_VIDEO_DETAIL = "/cms/Video/detail";
  public readonly CMS_VIDEOPOSTQUESTION = "cms/videoquestion";
  public readonly CMS_VIDEODELETEQUESTION = "/cms/videoquestion";
  public readonly CMS_VIDEO_BY_QUESTION_ID =
    "/cms/VideoQuestion/GetByQuestionId";

  public readonly CMS_LESSON_PLANS_SEARCH = "cms/lesson-plans/search";
  public readonly CMS_LESSON_PLANS_GET_BY_ID = "cms/lesson-plans/:lessonPlanId";
  public readonly CMS_LESSON_PLANS_GET_BY_SUBJECT_ID =
    "cms/lesson-plans/subjects/:subjectId";
  public readonly CMS_LESSON_PLANS_GET_SUBJECTS = "cms/lesson-plans/subjects";
  public readonly CMS_LESSON_PLANS_ADD = "cms/lesson-plans";
  public readonly CMS_LESSON_PLANS_UPDATE = "cms/lesson-plans/:lessonPlanId";
  public readonly CMS_LESSON_PLANS_ASSETS_ADD =
    "cms/lesson-plans/:lessonPlanId/assets";
  public readonly CMS_LESSON_PLANS_ASSETS_UPDATE =
    "cms/lesson-plans/:lessonPlanId/assets/:lessonPlanAssetId";
  public readonly CMS_LESSON_PLANS_ASSETS_GET_BY_LESSON_PLAN_ID =
    "cms/lesson-plans/:lessonPlanId/assets";
  public readonly CMS_LESSON_PLANS_ASSETS_GET_BY_ID =
    "cms/lesson-plans/:lessonPlanId/assets/:lessonPlanAssetId";
  public readonly CMS_LESSON_PLANS_ASSETS_GET_URL =
    "cms/lesson-plans/:lessonPlanId/assets/:lessonPlanAssetId/url";

  public readonly CMS_LEARNOSITY_RESUBMIT =
    "cms/failed-learnosity-sessions/resubmit";

  public readonly CMS_STANDARDS_SLIDES = "cms/standards/{standardId}/slides";
  public readonly CMS_STANDARDS_CREATE_SLIDE =
    "cms/standards/{standardId}/slides";
  public readonly CMS_STANDARDS_UPDATE_SLIDE = "cms/standards/slides/{slideId}";

  public readonly CMS_SLIDE = "cms/slide";
  public readonly CMS_SLIDES = "cms/slides";
  public readonly CMS_SLIDE_STANDARDS =
    "cms/standardslide/standards-by-slide/{slideId}";
  public readonly CMS_ASSOCIATE_SLIDES = "cms/slides/associate-standards";
  public readonly CMS_SLIDE_UNASSOCIATE_STANDARDS =
    "cms/slides/unassociate-standards";

  public readonly CMS_ASSOCIATE_QUESTIONS = "/cms/standard/associatedQuestions";
  public readonly CMS_ASSOCIATE_WORKSHEETS =
    "/cms/worksheet/associate-standards";
  public readonly CMS_ASSOCIATE_STANDARD_WORKSHEETS =
    "/cms/StandardWorksheet/associate-standard-worksheets";
  public readonly CMS_ASSOCIATE_VIDEOS = "/cms/video/associate-standards";
  public readonly CMS_ASSOCIATE_STANDARD_VIDEOS =
    "/cms/StandardVideo/associate-standard-videos";
  public readonly CMS_ASSOCIATE_STANDARD_SLIDES =
    "/cms/StandardSlide/associate-standard-slides";
  public readonly CMS_COPY_STANDARDS = "/cms/Standard/copyTodomain";
  public readonly CMS_VALIDATE_ASSOCIATE_QUESTION =
    "/cms/standard/validateQuestionAssociation";
  public readonly CMS_VALIDATE_ASSOCIATE_WORKSHEET =
    "/cms/standard/validateWorksheetAssociation";
  public readonly CMS_VALIDATE_ASSOCIATE_VIDEO =
    "/cms/standard/validateVideoAssociation";
  public readonly CMS_ASSOCIATE_QUESTIONS_DELETE =
    "/cms/standard/associatedQuestions";
  public readonly CMS_MULTIASSOCIATE_QUESTIONS_DELETE =
    "/cms/question/classify-cleanup";
  public readonly CMS_ASSOCIATE_STANDARDS_DELETE =
    "/cms/standard/associatedStandards";
  public readonly CMS_ASSOCIATE_QUESTION_STANDARDS =
    "/cms/question/associateStandards";
  public readonly CMS_GET_ASSOCIATED_QUESTIONS =
    "/cms/standard/associatedQuestions";
  public readonly CMS_STANDARD_BY_VIDEO = "cms/standard/standardsByVideoId";
  public readonly CMS_STANDARD_ICON = "cms/standard/uploadIcon";
  public readonly CMS_VIDEO_UNASSOCIATE_STANDARDS =
    "cms/video/unassociate-standards";
  public readonly CMS_GET_QUESTION_PAYLOAD_BY_ITEMREFRENCES =
    "/cms/question/question-payload-by-itemreference";
  public readonly CMS_STANDARDGROUP = "/cms/standardgroup";
  public readonly CMS_STANDARDGROUPStandard = "/cms/standardgroupstandard";
  public readonly CMS_GRADE_BY_ID = "cms/Grade/Detail";
  public readonly CMS_Profile = "/cms/profile";
  public readonly CMS_PERMISSION = "cms/Permission";
  public readonly CMS_PERMISSION_BY_ID = "cms/Permission/GetByPermissionId";

  public readonly CMS_USERPERMISSION = "cms/UserPermission";
  public readonly CMS_USERGROUPPERMISSION = "cms/UserGroupPermission";
  public readonly CMS_USERPERMISSION_BY_USERID =
    "cms/UserPermission/{userId}/userpermissions";
  public readonly CMS_USERGROUPPERMISSION_BY_USERID =
    "cms/UserGroupPermission/{userId}/usergrouppermissions";
  public readonly CMS_USERPERMISSION_GETALLBY_USERID =
    "cms/UserPermission/{userId}/all-userpermissions";
  public readonly CMS_USERPERMISSION_GETAUTHPERMISSIONS_BY_USERID =
    "cms/UserPermission/{userId}/authuserpermissions";
  public readonly CMS_USERPERMISSION_GETALLUSERS =
    "cms/UserPermission/GetAllUsers";

  public readonly CMS_USERPROFILESTATUS = "cms/user/GetProfileStatusByUserId";
  public readonly CMS_TEACHERS_GETBYSTATEID = "cms/teachersByStateId";
  public readonly CMS_CREATELOGINLINK = "cms/loginlinks";

  public readonly CMS_SUPERSHEET_ALL = "cms/supersheet/search";
  public readonly CMS_SUPERSHEET_GET = "cms/supersheet/detail";
  public readonly CMS_SUPERSHEET_SUBJECT_GETBYID =
    "cms/supersheet/subjects/getbyId";
  public readonly CMS_SUPERSHEET_ADD = "cms/supersheet";
  public readonly CMS_SUPERSHEET_UPDATE = "cms/supersheet";
  public readonly CMS_SUPERSHEET_PREVIEW = "cms/supersheet/preview";
  public readonly CMS_SUPERSHEET_DOWNLOADANSWERKEY =
    "cms/supersheet/downloadanswerkey";
  public readonly CMS_SUPERSHEET_Create = "cms/supersheet/create";
  public readonly CMS_SUPERSHEET_Validate = "cms/supersheet/validate";
  public readonly CalculatorTypes_GetAll = "cms/CalculatorType";
  public readonly CMS_SUPERSHEET_Subjects = "cms/supersheet/subjects";
  public readonly APP_TEACHERQUESTION = "app/teacherquestion";
  public readonly APP_QUESTIONTYPES_FOR_TEACHER = "app/question/questiontypes";
  public readonly CMS_ICON_PREVIEW = "cms/icon/preview";

  public readonly CMS_GALAXY_STAR_SUBS = "cms/SubjectGalaxyStar";
  public readonly CMS_GALAXY_STAR_SUBS_SAVE = "cms/SubjectGalaxyStar/save";

  public readonly CMS_MINI_CRM_USERS = "cms/users";
  public readonly CMS_MINI_CRM_USERS_EXPORT = "cms/users/export";
  public readonly CMS_MINI_CRM_USERS_CREATE = "cms/crm/user/create";
  public readonly CMS_MINI_CRM_USERS_UPDATE = "cms/crm/user/update";
  public readonly CMS_MINI_CRM_USERS_DELETE = "cms/crm/user/{userId}";
  public readonly CMS_MINI_CRM_USERS_REACTIVATE =
    "cms/crm/user/{userId}/reactivate";

  public readonly CMS_MINI_CRM_SCHOOLS = "cms/school";
  public readonly CMS_MINI_CRM_NWEA_SCHOOLS = "cms/nwea/schools";
  public readonly CMS_MINI_CRM_SCHOOLS_CREATE = "cms/crm/school/create";
  public readonly CMS_MINI_CRM_SCHOOLS_UPDATE = "cms/crm/school/update";
  public readonly CMS_MINI_CRM_SCHOOLS_DELETE = "cms/crm/school/delete";
  public readonly CMS_MINI_CRM_DISTRICTS = "cms/district";
  public readonly CMS_MINI_CRM_DISTRICTS_CREATE = "cms/crm/district/create";
  public readonly CMS_MINI_CRM_DISTRICTS_UPDATE = "cms/crm/district/update";
  public readonly CMS_MINI_CRM_DISTRICTS_DELETE = "cms/crm/district/delete";
  public readonly CMS_MINI_CRM_DISTRICTS_GET_ROSTER_CONNECTION_COUNTS =
    "cms/crm/districts/{districtId}/roster-connection-counts";
  public readonly CMS_MINI_CRM_DISTRICTS_DELETE_ROSTER_CONNECTIONS =
    "cms/crm/districts/{districtId}/roster-connections";
  public readonly CMS_MINI_CRM_CANVAS_ACCOUNTSETTINGS =
    "cms/canvas-account-settings/district";

  public readonly CMS_MINI_CRM_CANVAS_DISTRICTSCHOOLS =
    "cms/canvas-account-settings/schools-by-district";

  public readonly CMS_MINI_CRM_CANVAS_SCHOOLS =
    "cms/canvas-account-settings/schools";

  public readonly CMS_MINI_CRM_CANVAS_CREATE_ACCOUNTSETTINGS =
    "cms/canvas-account-settings";
  public readonly CMS_MINI_CRM_CANVAS_UPDATE_ACCOUNTSETTINGS =
    "cms/canvas-account-settings";

  public readonly CMS_MINI_CRM_DISTRICT_SYNC =
    "cms/ExternalRostersSync/District";

  public readonly UPDATE_USER_ROLE = "app/user/userrole";

  public readonly CMS_MINI_CRM_SCHOOLS_NWEA_GRADE_UPDATE =
    "cms/nwea/school/update";

  public readonly CMS_MINI_CRM_SCHOOLS_NWEA_GRADE_GET =
    "cms/nwea/schoolgrade/get";

  public readonly CMS_MINI_CRM_SCHOOLS_NWEA_SCHOOL_MAP = "cms/nwea/school/map";
  public readonly CMS_MINI_CRM_SCHOOLS_NWEA_SCHOOL_UNMAP =
    "cms/nwea/school/unmap";
  public readonly CMS_MINI_CRM_SCHOOLS_NWEA_SCHOOL_Update =
    "cms/nwea/school/updatenweaid";

  public readonly CMS_ACADEMICSACTIVITY = "/cms/AcademicsActivity";
  public readonly APP_USER_ADD = "app/User";

  public readonly FEEDBACK_GET_LASTUPDATED_RESOLUTIONS =
    "cms/feedback/getlastupdatedresolutions";
  public readonly FEEDBACK_GET_RESOLUTIONSBYFEEDBACKID =
    "cms/feedback/getresolutionsbyfeedbackid";

  public readonly FEEDBACK_GET_RESOLUTION_STATUSES =
    "cms/feedback/getfeedbackstatustypes";

  public readonly FEEDBACK_CREATE_RESOLUTION = "cms/feedback/create";

  public readonly FEEDBACK_UPDATE_RESOLUTION = "cms/feedback/update";

  public readonly TTS_API = {
    GetAudioFromText: "app/text-to-speech",
    CreatePassageSpeech: "app/text-to-speech/passages",
  };

  public readonly ForgotPassword_API = {
    GetAccountDetail: "/app/account/send-forgot-password-email",
  };

  public readonly GET_REQUEST = "cms/request";
  public readonly GET_REQUEST_PUBLIC = "cms/request-public";

  public readonly CMS_CRM_CONTENT_USER_INFO = "cms/user/{userId}/info";
  public readonly CMS_TEACHER_PASSAGE = "cms/teacher-passages";
  public readonly CMS_TEACHER_QUESTION = "cms/teacher-question";
  public readonly CMS_TEACHER_SUBJECTS = "cms/teacher/subjects";
  public readonly CMS_TEACHER_QUESTION_TYPE = "cms/question-type";
  public readonly CMS_TEACHER_QUESTION_TYPE_PAYLOAD =
    "cms/QuestionType/payload-teacher-schema";
  public readonly CMS_ASSESSMENT = "cms/assessment";
  public readonly CMS_ASSESSMENTS = "cms/assessments";
}

export default new APIConstant();
